import { useEffect } from "react";

const SHIPPING_ADDRESS_FORM_SELECTOR = '[data-component-name="ShippingAddressForm"]';

function getErrorsToScrollTo() {
  const shippingAddressForm = document.querySelector(SHIPPING_ADDRESS_FORM_SELECTOR);
  const shippingAddressErrors = shippingAddressForm?.querySelectorAll(".error");

  if (shippingAddressErrors?.length) {
    return shippingAddressErrors;
  }

  return document.querySelectorAll(".error");
}

function getTopmostVisibleErrorElement(errorElements) {
  const visibleErrors = [...errorElements].filter(element => {
    const { height, width } = element.getBoundingClientRect();
    return height > 0 && width > 0;
  });

  if (!visibleErrors.length) {
    return null;
  }

  return visibleErrors.sort(
    (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top
  )[0];
}

export default function useScrollToError(formApi) {
  useEffect(() => {
    if (!formApi.scrollToError) {
      return undefined;
    }

    let innerFrameId;

    const outerFrameId = requestAnimationFrame(() => {
      innerFrameId = requestAnimationFrame(() => {
        const error = getTopmostVisibleErrorElement(getErrorsToScrollTo());
        if (error) {
          error.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    });

    return () => {
      cancelAnimationFrame(outerFrameId);
      if (innerFrameId) {
        cancelAnimationFrame(innerFrameId);
      }
    };
  }, [formApi.scrollToError]);
}
